import { render, staticRenderFns } from "./ChannelId.vue?vue&type=template&id=58d41f22&scoped=true&"
import script from "./ChannelId.vue?vue&type=script&lang=js&"
export * from "./ChannelId.vue?vue&type=script&lang=js&"
import style0 from "./ChannelId.vue?vue&type=style&index=0&id=58d41f22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d41f22",
  null
  
)

export default component.exports